export default __webpack_public_path__ + "static/media/fideliser.de7d77f6.svg";